import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { updateFormData, nextStep } from '../../store/formSlice';
import {
    Button,
    Box,
    Text,
    VStack,
    Radio,
    RadioGroup,
    FormControl,
    FormErrorMessage,
    HStack
} from '@chakra-ui/react';
import StepHeader from './StepHeader';

const experiencesList = [
    'Building Connections',
    'Memory Sharing',
    'Health and Wellness',
    'Positive Reflections',
];

const ExperienceStep = React.memo(() => {
    const dispatch = useDispatch();
    const { formData } = useSelector((state) => state.form);
    const firstName = formData.firstName || 'First Name';

    const [experience, setExperience] = useState(formData.experiences || '');
    const [error, setError] = useState('');

    const handleChange = (value) => {
        setExperience(value);
        if (error) setError('');
    };

    const validate = () => {
        if (!experience) {
            setError('Please select an experience');
            return false;
        }
        setError('');
        return true;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validate()) {
            dispatch(updateFormData({ experiences: experience }));
            dispatch(nextStep());
        }
    };

    const isChecked = (value) => experience === value;

    return (
        <Box maxW="3xl" mx="auto" p={6} textAlign="center">
            <StepHeader
                title="What will they Experience?"
                subtitle={`What Will ${firstName} Enjoy During Their Calls?`}
            />
            <form onSubmit={handleSubmit}>
                <FormControl isInvalid={!!error} mb={8}>
                    <RadioGroup value={experience} onChange={handleChange}>
                        <VStack spacing={4} align="center">
                            {experiencesList.map((exp) => (
                                <Box
                                    key={exp}
                                    bg="white"
                                    border="1px solid"
                                    borderRadius="lg"
                                    borderColor="gray.200"
                                    p={{ base: 3, md: 4 }}
                                    w="100%"
                                    boxShadow={isChecked(exp) ? 'md' : 'sm'}
                                    transition="all 0.2s"
                                >
                                    <HStack>
                                        <Radio
                                            value={exp}
                                            colorScheme="brand"
                                            size="lg"
                                            borderColor={isChecked(exp) ? 'brand.500' : 'gray.300'}
                                            isChecked={isChecked(exp)}
                                        >
                                            <Text
                                                fontSize={{ base: '14px', md: '20px' }}
                                                color="black"
                                                fontWeight="normal"
                                                fontFamily="Nunito"
                                                pl={2}
                                                m={0}
                                                textAlign="left"
                                            >
                                                {exp}
                                            </Text>
                                        </Radio>
                                    </HStack>
                                </Box>
                            ))}
                        </VStack>
                    </RadioGroup>
                    <FormErrorMessage>{error}</FormErrorMessage>
                </FormControl>
                <Button
                    type="submit"
                    isDisabled={!experience}
                    mt={4}
                    px="30px"
                >
                    Continue
                </Button>
            </form>
        </Box>
    );
});

export default ExperienceStep;